import InfoIcon from '@mui/icons-material/Info';
import { alpha } from '@mui/material';
import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import { Box, BoxProps } from '../Box/Box';
import { Stack } from '../Stack/Stack';
import { Tooltip } from '../Tooltip/Tooltip';
import { Typography } from '../Typography/Typography';

export interface FieldSetProps extends Omit<BoxProps, 'component'> {
  legendText: string;
  infoIconText?: string | null;
}

export const FieldSet = (props: FieldSetProps) => {
  const { children, legendText, infoIconText, sx, ...restOfProps } = props;

  return (
    <Box
      {...restOfProps}
      sx={[
        (theme) => ({
          borderColor: alpha(theme.palette.common.black, 0.13),
          borderRadius: 1,
          display: 'flex'
        }),
        ...toSxArray(sx)
      ]}
      component={'fieldset'}>
      <legend>
        <Stack direction='row' sx={{ alignItems: 'center' }}>
          <Typography variant='h3' text={legendText} />
          {infoIconText && (
            <Tooltip title={infoIconText} placement={'top-end'}>
              <InfoIcon fontSize='small' color='primary' />
            </Tooltip>
          )}
        </Stack>
      </legend>
      {children}
    </Box>
  );
};
